import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { JwtHelperService } from '@auth0/angular-jwt';
import { environment } from '../environments/environment';

@Component({
  selector: 'iq-central-front-end-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
  activeNav = false;
  activeCourse = false;
  token: any;
  activeSet = false;
  activePath = false;
  @Output() routeChoosen = new EventEmitter();
  userDatils: any;
  userId: any;
  name: any;
  destinationUrl = `${environment.FRONTEND_HOMEPAGE_URL}/login`;

  constructor(
    private activeRoute: ActivatedRoute,
    private router: Router,
    private _jwt: JwtHelperService
  ) {}

  ngOnInit() {
    this.getLoggedInUser();
    const contentProviderDetails = JSON.stringify(this.userDatils);
    localStorage.setItem('userDetails', contentProviderDetails);

    this.activeRoute.url.subscribe((url) => {
      if (url.length === 0) {
        this.activeRoute.parent.url.subscribe((res) => {
          this.activeCourse = res[0].path === 'courses' ? true : false;
          this.activeSet = res[0].path === 'profile' ? true : false;
        });
      } else {
        this.activeNav = url[0].path === 'dashboard' ? true : false;
        if (url[0].path !== 'dashboard') {
          this.activeRoute.parent.url.subscribe((update) => {
            if (update.length !== 0) {
              if (update[0].path === 'courses') {
                this.activeCourse = true;
              }
            }
          });
        }
      }
    });
  }

  gotoCourses() {
    this.routeChoosen.emit('courses');
  }

  goToDashboard() {
    this.routeChoosen.emit('dashboard');
  }

  goToSettings() {
    this.routeChoosen.emit('profile');
  }

  goToCategories() {
    this.routeChoosen.emit('categories');
  }

  goToLearningPath() {
    this.routeChoosen.emit('learningPaths');
  }

  logout() {
    localStorage.removeItem('token');
    window.location.href = this.destinationUrl;
  }

  loggedIn(): boolean {
    const token = localStorage.getItem('token');
    return (
      localStorage.getItem('token') !== null || !this._jwt.isTokenExpired(token)
    );
  }

  getLoggedInUser() {
    if (this.loggedIn()) {
      this.token = localStorage.getItem('token');
      this.userDatils = this._jwt.decodeToken(this.token);
      this.userId = this.userDatils.user_id;
      this.name = localStorage.getItem('lastName');
    }
  }
}
